import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute, Router, RouteConfigLoadStart,
  ResolveStart, RouteConfigLoadEnd, ResolveEnd
} from '@angular/router';
import { SessionService } from 'src/app/store/session/session.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { PasswordValidators } from 'ngx-validators';
import { SessionQuery } from 'src/app/store/session/session.query';
import { Observable } from 'rxjs';
import { SharedAnimations } from 'src/app/shared/animations/shared-animations';
import { ToastrService } from 'ngx-toastr';
import { StatusRegisterResponse } from 'src/app/shared/model/login';
import { getPasswordRules } from 'src/app/shared/password-rules';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { environment } from '@env/environment';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  animations: [SharedAnimations]
})
export class RegisterComponent implements OnInit {

  form: FormGroup;
  loading$: Observable<boolean>;
  userId: string;
  verifyCode: string;
  loadingText: string;

  public readonly termsOfUse = environment.docs.termsAndConditionsOfUse;

  showPassword = false;
  showConfirmPassword = false;
  passwordValidators = [];

  tokenInvalid = false;
  isVerify = false;
  verifySuccess = false;
  dealerMissingAddress = false;
  invalidZipCode: boolean;

  constructor(
    private route: ActivatedRoute,
    private sessionService: SessionService,
    private sessionQuery: SessionQuery,
    private applicationService: ApplicationService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {

    this.loading$ = this.sessionQuery.selectLoading();
    this.isVerify = true;

    this.passwordValidators = getPasswordRules();
    const validatorsPassword = this.passwordValidators.map(v => v.validator);
    validatorsPassword.push(Validators.required);

    this.form = this.fb.group({
      name: ['', [Validators.required]],
      email: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
      password: ['', validatorsPassword],
      passwordConfirm: ['', [Validators.required]],
      acceptTerm: [false, [Validators.requiredTrue]]
    }, {
      validators: [PasswordValidators.mismatchedPasswords('password', 'passwordConfirm')]
    });

    const { user, code } = this.route.snapshot.queryParams;
    this.userId = user;
    this.verifyCode = code;
    this.sessionService.verifyUser(user, code).subscribe((response) => {
      this.isVerify = false;
      this.verifySuccess = response.success;
      if (response.success) {
        this.dealerMissingAddress = response.dealerMissingAddress;
        this.form.patchValue({
          email: response.email
        });

        if (this.dealerMissingAddress) {
          this.form.addControl('phoneNumber',
            new FormControl('', [Validators.required]));
          this.form.addControl('zipCode',
            new FormControl('', {
              validators: Validators.required,
              updateOn: 'blur'
            }));
          this.form.addControl('address',
            new FormControl({ value: '' }, [Validators.required]));
          this.form.addControl('addressNumber', new FormControl('', [Validators.required]));
          this.form.addControl('addressComplement',
            new FormControl('', []));
          this.form.addControl('district',
            new FormControl({ value: '' }, [Validators.required]));
          this.form.addControl('cityName',
            new FormControl({ value: '', disabled: true }, []));
          this.form.addControl('uf',
            new FormControl({ value: '', disabled: true }, []));
        }
      } else {
        this.tokenInvalid = true;
      }
    }, _ => {
      this.isVerify = true;

    });


    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
        this.loadingText = 'Redirecionando para o login...';
        this.sessionService.setLoading(true);
      }
      if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
        this.sessionService.setLoading(false);
      }
    });
  }

  updateZipCode(): void {
    let zipCode = this.form.get('zipCode').value;
    zipCode = zipCode.replace(/\D/g, '');
    if (zipCode.length === 8) {
      this.applicationService.getCep(zipCode).subscribe(response => {
        this.invalidZipCode = response.erro;

        if (!this.invalidZipCode) {
          this.form.get('address').setValue(response.logradouro);
          this.form.get('cityName').setValue(response.localidade);
          this.form.get('uf').setValue(response.uf);
          this.form.get('zipCode').setValue(response.cep);
          this.form.get('district').setValue(response.bairro);
        }
      });
    } else {
      this.invalidZipCode = true;
    }
  }

  onSubmit(values) {
    this.sessionService.setLoading(true);
    this.loadingText = 'Aguarde...';
    this.sessionService.registerUser(this.userId, this.verifyCode, values).subscribe(response => {
      if (response.success) {
        this.toastr.success('', 'Cadastro realizado com sucesso. Aguarde enquanto você é redirecionado para a página inicial.', {
          timeOut: 3000,
          closeButton: false,
          progressBar: true,
          positionClass: 'toast-bottom-center'
        });
        setTimeout(() => {
          this.sessionService.login(values.email, values.password);
        }, 3000);


      } else {
        let message = StatusRegisterResponse[response.status];
        if (message === StatusRegisterResponse.ALREADY_REGISTERED) {
          message += ` Aguarde enquanto você é redirecionado para a página de recuperação de senha.`;
          setTimeout(() => {
            this.router.navigate(['/login/resetPassword'], { queryParams: { user: this.userId, code: this.verifyCode } });
          }, 10000);
        }
        this.toastr.error('', message,
          {
            closeButton: true,
            progressBar: true,
            positionClass: 'toast-bottom-center',
            extendedTimeOut: 5000,
            timeOut: 10000
          });
      }

    }, err => {
      this.toastr.error('', `Não foi possível realizar seu cadastro.`);
    });
  }

  get password(): FormControl {
    return this.form.get('password') as FormControl;
  }
}
